import { Button } from '@shared/components/ui/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileArrowDown, faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import { FilterConditionOutput } from '@shared/components/ui/AdvancedFilter';
import { useExportOrders } from '../../hooks/useExportOrders';

interface Props {
  filterConditions: FilterConditionOutput[];
  searchFilter?: { filters: any[]; logic: string };
  statusId?: number;
  shipmentStatusId?: number;
  sorting?: { field: string; direction: 'asc' | 'desc' };
  visibleColumns?: string[];
}

export const DownloadExcelButton: React.FC<Props> = ({
  filterConditions,
  searchFilter,
  statusId,
  shipmentStatusId,
  sorting,
  visibleColumns,
}) => {
  const { t } = useTranslation('ordersShippedModule');
  const { exportOrders, isExporting } = useExportOrders();

  const handleExport = () => {
    exportOrders(filterConditions, searchFilter, statusId, shipmentStatusId, sorting, visibleColumns);
  };

  return (
    <Button
      onClick={handleExport}
      disabled={isExporting}
      type="button"
      size="sm"
      variant="outline"
      className="!py-[9px] !px-2 !text-icons"
      data-testid="export-excel-button"
    >
      {isExporting ? (
        <FontAwesomeIcon icon={faSpinnerThird} className="animate-spin" />
      ) : (
        <FontAwesomeIcon icon={faFileArrowDown} />
      )}
    </Button>
  );
};
